import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'antd';

import useDatasource from '../../hooks/useDatasource';
import { FormContext } from '../../hooks/useForm';
import Column from '../../helpers/columns';
import FormWrapper from '../FormWrapper';
import { getUserTypesLight } from '../../services/taxonomies/user-types';

const PosUserTypesList = ({ canEdit = true }) => {
  const form = useContext(FormContext);

  const { t } = useTranslation();

  const { value, setValue, errorMessages } = form;

  const { userTypes } = value;

  const columns = useMemo(
    () => [
      Column.text('name', t('entity.taxonomy.userType.name'), {
        filter: true,
      }),
    ],
    [t],
  );

  const rowSelection = useMemo(
    () => ({
      selectedRowKeys: userTypes,
      onSelect: (record, selected) =>
        selected
          ? setValue('userTypes', [...(userTypes || []), record.id])
          : setValue(
              'userTypes',
              userTypes.filter((id) => id !== record.id),
            ),
      getCheckboxProps: ({ deleted, id }) => ({
        disabled: deleted && !userTypes.some((pgId) => pgId === id),
      }),
    }),
    [userTypes, setValue],
  );

  const { pagination, content, handleChange } =
    useDatasource(getUserTypesLight);

  return (
    <>
      <FormWrapper.ErrorMessage message={t(errorMessages?.userTypes)} />
      <Table
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
          getCheckboxProps: () => ({
            disabled: !canEdit,
          }),
        }}
        columns={columns}
        rowKey="id"
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
      />
    </>
  );
};

export default PosUserTypesList;
